import { MoreVertical, ChevronLast, ChevronFirst } from "lucide-react";
import { useContext, createContext, useState } from "react";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from "react";
import { IconButton, Avatar } from "@mui/material";
import aiwelllogo from '../Assets/images/Aiwell Logo 1 1.png'
import aiwelllogo2 from '../Assets/images/Aiwell logo 1-1 (1).png'
import Profileicon from '../Assets/images/Profile.png'
import settingsicon from '../Assets/images/settings_black.png'
import { useLocation } from "react-router-dom";
import profileiconblk from '../Assets/images/profile_black.png'
import Dialog from '@mui/material/Dialog';
import { ChevronDown, ChevronUp } from "lucide-react";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import logoutblkicon from '../Assets/images/logout_black.png'
import { useNavigate } from "react-router-dom";
import { logout } from "../Auth/AuthUtil";
import leftarrow from '../Assets/images/left arrow 2.png';
import rightarrow from '../Assets/images/right arrow 2.png';
import { Visibility } from "@mui/icons-material";

const SidebarContext = createContext();

export default function Sidebar({ children }) {

    const [expanded, setExpanded] = useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const [opendialog, setOpendialog] = useState(false);

    const handleClickOpendialog = () => {
        setOpendialog(true);
    };

    const handleCloseDialog = () => {
        setOpendialog(false);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        console.log(event);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <aside className={`h-screen shadow-md transition-width duration-300 ${expanded ? "w-64" : "w-18 h-18"}`} id="sidebar">
            <nav className="h-full flex flex-col overflow-hidden border-r shadow-sm">

                {/* Logo Section */}
                <div className="p-3 pb-2 flex justify-between items-center">
                    <img
                        src={aiwelllogo}
                        className={`overflow-hidden transition-all ${expanded ? "w-40" : "w-0 ml-5 hidden"}`}
                        alt="Logo"
                    />
                </div>

                {!expanded && (
                    <div className="w-full flex flex-row items-center justify-center">
                        <img src={aiwelllogo2} className="w-14 p-1" alt="Logo Collapsed" />
                    </div>
                )}

                {/* Scrollable Menu Section */}
                <SidebarContext.Provider value={{ expanded }}>
                    <div className="flex-1 overflow-y-auto px-3 mt-5 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
                        <ul>
                            {children}
                        </ul>
                    </div>
                </SidebarContext.Provider>


                <div className="border-t px-3 w-full" >
                    <div className="py-2 px-3 my-1 mt-3">
                        <div
                            className={`flex w-full profileaction ${expanded ? "flex-row" : "flex-col"} items-center `}
                            onClick={handleClick}
                        >
                            <img src={Profileicon} style={{ width: "2rem" }} alt="Profile" />
                            <p style={expanded ? {} : { visibility: "hidden" }} className="text-[#75623F]">Profile</p>
                        </div>
                    </div>
                </div>

                <div className="p-3 pb-2 flex items-center" style={expanded ? { justifyContent: "flex-end" } : { alignSelf: "center" }}>
                    <button onClick={() => setExpanded(curr => !curr)} className="p-1.5 rounded-lg">
                        {expanded ? (
                            <img src={leftarrow} className="w-10" alt="Collapse" />
                        ) : (
                            <img src={rightarrow} className="w-10" alt="Expand" />
                        )}
                    </button>
                </div>

                {/* Profile Menu */}
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={() => navigate('Profilepage')}>
                        <div className="menuitem">
                            <p>View Profile</p>
                            <img src={profileiconblk} alt="Profile Icon" />
                        </div>
                    </MenuItem>
                    <MenuItem onClick={() => navigate('Settings')}>
                        <div className="menuitem">
                            <p>Settings</p>
                            <img src={settingsicon} alt="Settings Icon" />
                        </div>
                    </MenuItem>
                    <MenuItem onClick={handleClickOpendialog}>
                        <div className="menuitem">
                            <p>Logout</p>
                            <img src={logoutblkicon} alt="Logout Icon" />
                        </div>
                    </MenuItem>
                </Menu>
            </nav>

            {/* Logout Confirmation Dialog */}
            <Dialog
                open={opendialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Logout"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to log out?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{
                            textTransform: 'none',
                            border: '1px solid #DA6E0B',
                            color: '#DA6E0B',
                            borderRadius: '5px',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: '10px'
                        }}
                        onClick={handleCloseDialog}
                    >
                        No
                    </Button>
                    <Button
                        style={{
                            textTransform: 'none',
                            backgroundColor: '#DA6E0B',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: '10px'
                        }}
                        onClick={() => {
                            logout();
                            handleCloseDialog();
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </aside>

    );
}

export function SidebarItem({ icon, text, path, activeIcon, children = [] }) {
    const { expanded } = useContext(SidebarContext);
    const location = useLocation();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);

    const menuOpen = Boolean(anchorEl);

    const isActive = path
        ? location.pathname === path
        : children.some((child) => location.pathname === child.path);

    const handleMenuOpen = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => setAnchorEl(null);

    const handleNavigate = (e) => {

        if (e.target.closest(".dropdown-trigger")) {
            return;
        }

        if (path) navigate(path);

    };

    return (

        <li className="w-full">
            <div
                className={`relative flex items-center py-2 px-3 my-1 mt-3 font-medium rounded-md cursor-pointer transition-colors group 
                ${isActive ? "bg-[#75623F] text-white" : "hover:bg-[#D4CEC3] text-[#75623F]"}`}
                onClick={handleNavigate}
            >
                {expanded ? (
                    <img
                        src={isActive ? activeIcon || icon : icon}
                        alt={text}
                        style={{ width: "2rem", display: "block" }}
                    />
                ) : (
                    <div className="ml-2">
                        <img
                            src={isActive ? activeIcon || icon : icon}
                            alt={text}
                            style={{ width: "2rem", display: "block" }}
                        />
                    </div>
                )}

                {expanded && (
                    <>
                        <span className="flex-1 overflow-hidden transition-all ml-3">{text}</span>
                        {children.length > 0 && (
                            <span
                                className="dropdown-trigger cursor-pointer"
                                onClick={handleMenuOpen}
                            >
                                <ChevronDown size={18} />
                            </span>
                        )}
                    </>
                )}
            </div>

            <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                {children.map(({ label, path: childPath }) => (
                    <MenuItem
                        key={childPath}
                        onClick={() => {
                            navigate(childPath);
                            handleMenuClose();
                        }}
                    >
                        {label}
                    </MenuItem>
                ))}
            </Menu>
        </li>
    );
}





